import { createFileRoute, redirect } from "@tanstack/react-router";

import { isSkuStoreStoriesEnabled } from "@/features/SKUStore/flag";
import { SKUStoreCreateEditStoryPage } from "@/features/SKUStore/SKUStoreCreateEditStoryPage";

export const Route = createFileRoute(
  "/_auth/sku-store/$siteId/$skuId/stories/new",
)({
  beforeLoad: ({ params }) => {
    if (!isSkuStoreStoriesEnabled()) {
      throw redirect({
        to: "/sku-store/$siteId/$skuId",
        params: { siteId: params.siteId, skuId: params.skuId },
      });
    }
  },
  component: SKUStoreCreateEditStoryPage,
});
